import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.FETCH_NEW_REPORT_REQUEST,
    SUCCESS: types.FETCH_NEW_REPORT_SUCCESS,
    FAILURE: types.FETCH_NEW_REPORT_FAILURE,
    CANCEL: types.FETCH_NEW_REPORT_CANCEL,
    RESET: types.FETCH_NEW_REPORT_RESET,
};

export default ReduxUtils.basicApiReducer({
    actionTypes,
});
